export enum DocumentReviewLevel {
  MemberValidation = 1,
  MemberAndDosValidationRisk = 2,
  MemberAndDosValidationIva = 3,
}
